import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private _config: any = false;

  constructor(private http: HttpClient) {}
  async getConfig() {
    const headers = { 'Content-Type': 'application/json' };
    // store config in memory as a singleton instance
    if (this._config) {
      console.log(`Loading '${environment.name}' config from cache.`);
      return Promise.resolve(this._config);
    }
    console.log(`Loading '${environment.name}' config from network.`);
    const config: any = await this.http
      .get(`assets/config/${environment.name}-config.json`, { headers })
      .toPromise();
    this._config = config;
    return config;
  }

  setConfig(cfg: any) {
    this._config = cfg;
  }
}
